<template>
  <v-card outlined class="mt-6">
    <v-row class="d-flex">
      <v-col class="pa-6" cols="10">
        <div class="d-flex align-end justify-space-between">
          <div>
            <div>Học phần</div>
            <h2>{{ grade | getGradeTitle }}</h2>
          </div>
          <div>
            <div>Bộ môn</div>
            <div class="font-weight-bold">{{ grade.academicLevel | getAcademicLevel }}</div>
          </div>
          <div>
            <div>Chương trình đào tạo</div>
            <div class="font-weight-bold">{{ grade.division | getDivision }}</div>
          </div>

          <div>
            <div>Buổi học</div>
            <div class="font-weight-bold">{{ grade.totalDate }}</div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: { grade: Object },
  filters: {
    getDivision(division) {
      if (!division) return '--'
      return division.title
    },
    getAcademicLevel(academicLevel) {
      if (!academicLevel) return '--'
      return academicLevel.title
    },
    getGradeTitle(grade) {
      if (!grade) return '--'
      return `${grade.code} - ${grade.title}`
    },
  },
}
</script>
